export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12139.8ebbe1d8.jpg";